import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Table } from 'primeng/table';
import { DynamicTransientDataServiceProxy, GetDynamicTransientDataOutputDto } from '@shared/service-proxies/service-proxies';
import { WidgetComponentBase } from '../widget-component-base';
import { CacheService } from '@app/shared/common/cacheService/cache.service';

@Component({
  selector: 'app-widget-revenue-dashboard',
  templateUrl: './widget-revenue-dashboard.component.html',
  styleUrls: ['./widget-revenue-dashboard.component.css']
})
export class WidgetRevenueDashboardComponent extends WidgetComponentBase implements OnInit{

  loading = true;
  revenueDatas: any;
  cacheData: any;

  @ViewChild('RevenueDatasTable', { static: true }) revenueDatasTable: Table;

  constructor(injector: Injector,
    private _dynamicTransientDataServiceProxy: DynamicTransientDataServiceProxy,
    private cacheService: CacheService) {
    super(injector);
  }

  ngOnInit() {
    this.getDynamicTransientDataService();
  }

  getDynamicTransientDataService() {
    const cachedData = this.cacheService.getCachedData('dynamicTransientData');

    const fetchData = () => {
      this._dynamicTransientDataServiceProxy.getDynamicTransientData(undefined, undefined, "CA.Dashboard.Revenue")
        .subscribe((res: any) => {
          this.revenueDatas = JSON.parse(res[0].keyValue);
          this.cacheService.saveToLocalStorage('dynamicTransientData',this.revenueDatas);
          this.loading = false;
        });
    };

    if (cachedData) {
      if (this.cacheService.checkedIfExpired(cachedData.timestamp, 7200)) {
        fetchData();
      } else {
        this.revenueDatas = cachedData.data;
        this.loading = false;
      }
    } else {
      fetchData();
    }
   
  }
}
